import { useNavigate } from "react-router-dom";
import Heading from "./Heading";

export default function ContactUs() {
  const navigate = useNavigate();

  const handleBackButton = (event) => {
    event.preventDefault();
    navigate("/login");
  };

  return (
    <>
      <Heading />
      <div className="card m-5">
        <div className="card-header bg-white text-black fs-4 fw-bold">
          Contact Us
        </div>
        <div className="card-body">
          <div className="row fs-5 fw-bold">
            <div className="col-md-6 col-12 mb-2">
              Query Type
              <div className="fw-normal fs-6 mt-2">
                Login or first-time registration related issues or any technical issues.
              </div>
            </div>

            <div className="col-md-6 col-12 mb-2">
              How to Contact?
              <div className="fw-normal fs-6 mt-2">
                {/* If you have any queries, please refer to the{" "}
                <a
                  href={`${process.env.PUBLIC_URL}/CET_Admit_Card_FAQs.pdf`}
                  download
                  style={{ textDecoration: "none" }}
                >
                  <strong>FAQ</strong>
                </a>
                . */}
                <hr className="d-none d-md-block" />
                <div className="mt-2">
                  Please feel free to call us at the numbers provided.
                  {/* If your question hasn't been answered yet: */}
                  <br/>
                  <strong>Phone:</strong> 01732310850 (working days, 10 AM - 6 PM)
                  <br/>
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center mb-5">
        <button className="btn btn-success text-white" onClick={handleBackButton}>
          Back to Home Page
        </button>
      </div>
    </>
  );
}
